import type { ContentIntakeMode } from '@domain/content-intake';

export interface IntakeModeTab {
  id: ContentIntakeMode;
  label: string;
}

export const INTAKE_MODE_TABS: IntakeModeTab[] = [
  { id: 'url', label: 'Add URL' },
  { id: 'paste', label: 'Paste Content' },
  { id: 'seo_package', label: 'SEO Package' },
];

export function intakeModeLabel(mode: ContentIntakeMode): string {
  return INTAKE_MODE_TABS.find((t) => t.id === mode)?.label ?? mode;
}
